export default __webpack_public_path__ + "static/media/emptyAddressesList.9698b71e.png";